import angular from 'angular';
import directive from './category-graph.directive';
import controller from './category-graph.controller';


export default angular.module('app.components.advisory.ecat.categoryGraph', [])
  .directive('ecatCategoryGraph', directive)
  .controller('ECATCategoryGraphController', controller)
  .name;

console.log('app.components.advisory.ecat.categoryGraph created');
